<template lang="pug">
panel-base(
  :value="displayValue"
  v-bind="$attrs"
  v-on="actionEvents"
)
  server-data(
    :key="refreshKey"
    search-field-name="search[name]"
    :value="[]"
    :method="getItems"
    :serialize-data-items="serializeItems"
    :debounce-delay="500"
    :start-loading-value="true"
    v-slot="{ serverData: items, loading: isLoading, search }"
  )
    app-text-input(
      append-icon="$izoom"
      clearable
      v-bind="inputAttrs"
      @input="search"
    )

    template(v-if="isLoading")
      template(v-for="i in constants.ITEM_SKELETON_COUNT")
        v-skeleton-loader(
          type="list-item"
        )

    template(v-else)
      app-list.list
        template(v-if="!!items.length")
          app-list-item-group(
            v-model="selectedItem"
          )
            template(v-for="item in items")
              app-list-item(
                :value="item"
                :input-value="inputValue && inputValue.id === item.id"
              )
                v-list-item-content {{ item.name }}
        template(v-else)
          app-list-item
            | Не найдено
      //- app-button(
      //-   rounded
      //-   :disabled="isSelectButtonDisabled"
      //-   @click="selectItem"
      //- ).mt-2 Выбрать
</template>

<script>
import PanelBase from './PanelBase.vue';
import { ROW_ACTION_KEY, LIST_SKELETON_COUNT } from '../constants';
import { PER_PAGE } from '@/constants/pagination';

export default {
  name: 'PanelDirectory',
  components: {
    PanelBase,
  },
  props: {
    /**
     *  value: {
     *    id: number;
     *    name: string;
     *  };
     */
    value: {
      type: Object,
      default: () => null,
    },
    apiMethod: {
      type: Function,
      required: true,
    },
    apiQuery: {
      type: Object,
      default: () => ({}),
    },
    refreshKey: {
      type: [String, Number],
      default: '',
    },
    inputAttrs: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedItem: this.value,
    };
  },
  computed: {
    constants() {
      return {
        LIST_SKELETON_COUNT,
      };
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    displayValue() {
      return this.inputValue?.name;
    },
    actionEvents() {
      const { reset } = ROW_ACTION_KEY;
      const resetAction = `click:${reset}`;

      return {
        [resetAction]: () => {
          this.selectedItem = null;
          this.inputValue = null;
          this.$emit(resetAction);
        },
        ...this.$listeners,
      };
    },
    isSelectButtonDisabled() {
      return !this.selectedItem || this.inputValue?.id === this.selectedItem?.id;
    },
  },
  watch: {
    selectedItem() {
      if (!this.isSelectButtonDisabled) this.selectItem();
    },
  },
  created() {},
  methods: {
    getItems(additionalParams = {}) {
      const params = {
        ...additionalParams?.params || additionalParams,
        'per-page': PER_PAGE.infinity,
        sort: 'name',
        ...this.apiQuery,
      };

      return this.apiMethod({ params });
    },
    serializeItems(items) {
      return items.map(({ id, name }) => ({ id, name }));
    },
    selectItem() {
      this.inputValue = this.selectedItem;
      this.$emit('click:select');
    },
  },
};
</script>
